import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ButtonLoader from '../../Elements/Button/button';
//import '../../../assets/css/siicex-usuario.css';

import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../../constants';
import {OPTIONS_ACTIVE} from '../../../constants';
import Error from '../../Error/error';

import {DropDownList} from '../../Elements/Select/dropdown';
import {DropDownListChild} from '../../Elements/Select/dropdown';


export default class edit_tipo_recurso extends Component {

    constructor(props) {
        super(props);

        this.state = {
            nNumero: '',
            resource: [],
            response: [],
            error: [],
            key: 0,
            loading : false,
            add: false
          }
    
        this.handleInputChange = this.handleInputChange.bind(this);
      }
    
    

      handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
          
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource[target.name] = value;
            
        this.setState({
            resource: copyResource
        });
    }

    componentDidMount(){
        
        var key = this.props.location.state.key;
        const url = `${API_URL}ResourceTypeUX/${key}`;
        
        axios.get(url).then(response => response.data)
        .then((data) => {
            
            this.setState({ resource: data.result, response: data, error: data.Error });
            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            document.querySelector('.loader').classList.add('loader--hide');
            toast.error("¡Error al cargar los Recursos!");
            console.log(error);
        });

    }

    

     handleClickCancel(e) {
        const {history: {push}} = this.props;    
        push('/tipo-recurso');
     }

     callFunctionButton = (event) => {

        this.setState({loading:true});

        const {history: {push}} = this.props;    
        const url = `${API_URL}ResourceTypeUX/`;

        const formData = JSON.stringify(this.state.resource);
        
        console.log(formData);

        axios.put(
            url, 
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {             
                    console.log(data);
                    
                    if (data.data.isSucess)
                    {
                        toast.success('Recurso registrado correctamente. \n Se redireccionará al listado');
                        setTimeout(() => { push('/tipo-recurso');}, 1000);  
                    } else 
                    {
                        this.setState({loading:false});
                        toast.error('Error en el registro');
                    }
                }
            ).catch((error)=> {
                toast.error('Error no controlado');
                this.setState({loading:false});
            }); 
     }



    render() {
        return ( 
                (this.state.response.statusCode==200)?
                (
                    <div id="detailBody" className="Site-content" >
                        <div className="loader"></div> 
                        <form id="frmResource" name="frmResource" onSubmit={this.handleClickSubmit} >

                            <input type="hidden" id="dFechaModificacion" name="dFechaModificacion" defaultValue={this.state.resource.dFechaModificacion} />
                            <input type="hidden" id="dFechaPublicacion" name="dFechaPublicacion" defaultValue={this.state.resource.dFechaPublicacion} />
                            <input type="hidden" id="nUsuarioCreacion" name="nUsuarioCreacion" defaultValue={this.state.resource.nUsuarioCreacion} />
                            <input type="hidden" id="nUsuarioModificacion" name="nUsuarioModificacion" defaultValue={this.state.resource.nUsuarioModificacion} />
                            
                            <div hidden={false} id="content-wrapper" className="d-flex flex-column">
                            <div id="content">
                                <div id="Body" className="body-container container-fluid">
                                    <div className="content-option">
                                         <div className="row ">
                                            <div className="col-md-5 ">
                                                <div className="boletin__filters section__margin-bottom">
                                                    <div className="form-group">
                                                        <label htmlFor="nTipoRecursoCodigo"><strong>Código</strong></label>
                                                        <input type="text" readOnly name="nTipoRecursoCodigo" onChange={this.handleInputChange} id="nTipoRecursoCodigo" defaultValue={this.state.resource.nTipoRecursoCodigo} className="form-control text-filter__form-control" placeholder="Código" />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="sDescripcion"><strong>Descripción</strong></label>
                                                        <input type="text" name="sDescripcion" id="sDescripcion" onChange={this.handleInputChange} defaultValue={this.state.resource.sDescripcion} className="form-control text-filter__form-control" placeholder="Código" />
                                                    </div> 
                                                    <div className="form-group">
                                                        <label htmlFor="sCodigo"><strong>Codigo</strong></label>
                                                        <input type="text" name="sCodigo" id="sCodigo" onChange={this.handleInputChange} defaultValue={this.state.resource.sCodigo} className="form-control text-filter__form-control" placeholder="Código" />
                                                    </div> 
                                                    <div className="form-group">
                                                        <label htmlFor="nOrden"><strong>Orden</strong></label>
                                                        <input type="text" name="nOrden" id="nOrden" onChange={this.handleInputChange} defaultValue={this.state.resource.nOrden} className="form-control text-filter__form-control" placeholder="Orden" />
                                                    </div> 
                                                    <div className="form-group">
                                                        <label htmlFor="cEstado"><strong>Estado</strong></label>
                                                        <div className="">
                                                            <DropDownList name="cEstado" id="cEstado"  onChange={this.handleInputChange} clave={this.state.resource.cEstado} componente={"Estado"} />
                                                        </div>
                                                    </div>                                                                                                                                                           
                                                    <div className="form-group">
                                                        <label htmlFor="bActivo"><strong>Activo</strong></label>
                                                        <div className="">
                                                            <DropDownList name="bActivo" id="bActivo"  onChange={this.handleInputChange} clave={this.state.resource.bActivo} componente={"Activo"} />
                                                        </div>
                                                    </div> 
                                                </div>                                     
                                            </div>
                                            <div className="col-md-7 ">
                                                <div className="">
                                                    <strong><hr/></strong>
                                                    <strong>FECHA DE CREACIÓN:</strong> {this.state.resource.dFechaCreacion}
                                                    <br/> 
                                                    <strong>CREADO POR</strong> : MIGUEL QUIROZ 
                                                    <br/><br/>
                                                    <strong>FECHA DE MODIFICACIÓN:</strong> {this.state.resource.dFechaModificacion}
                                                    <br/> 
                                                    <strong>MODIFICADO POR:</strong> MIGUEL QUIROZ

                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-8">
                                                <button type="button" onClick={(event) => this.handleClickCancel(event)} className="btn btn-default btn-primary__submit">Cancelar</button> 
                                                &nbsp;
                                                <ButtonLoader text="GUARDAR" textProcessing="PROCESANDO..." loading={this.state.loading} callFunctionButton={() => this.callFunctionButton()}></ButtonLoader>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </form>
                    </div>    
                )
                :
                (
                    <Error StatusCode="500" StatusMessage="Error"></Error>
                )
                );
    }
}
